
export enum plinthType {
    none = 'none',
    H = 'H',
    G = 'G',
    Custom = 'Custom'
}